// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';
import './ObservationModal.scss';

import { Modal } from 'react-bootstrap';
import { storage } from '../../context/firebase';

import { fetchImageUrl } from '../../shared_components/utils/ImgUtils';
import LoadingIcon from '../LoadingIcon/LoadingIcon';
import SwipeableContainer from '../SwipeableContainer/SwipeableContainer';

import close_icon from '../../assets/icons/white/close.svg';
import back_icon from '../../assets/icons/white/back_small.png';

export default function ObservationModal({ observation, onHide, scrollObservation }) {
  const [image, setImage] = React.useState(null);

  React.useEffect(() => {
    setImage(null);
    fetchImageUrl(storage, observation.image_storage_path).then((url) => {
      const img = new Image();
      img.src = url;
      img.onload = () => {
        setImage(img);
      };
    });
  }, [observation?.image_storage_path]);

  return (
    <Modal show={true} onHide={onHide} backdrop='static' className='modal'>
      <div className='modal-box observation-modal'>
        <div className='close-button' onClick={onHide}>
          <img src={close_icon} />
        </div>

        <SwipeableContainer onSwipeLeft={() => scrollObservation(1)} onSwipeRight={() => scrollObservation(-1)}>
          {image && <img className='observation-image' src={image?.src} />}
        </SwipeableContainer>

        {/* Loading spinner */}
        {!image && <LoadingIcon />}

        {/* Buttons to jump to previous/next observation */}
        <div className='observation-footer'>
          <button className='observation-swipe-button prev' onClick={() => scrollObservation(1)}>
            <img src={back_icon} />
          </button>
          <button className='observation-swipe-button next' onClick={() => scrollObservation(-1)}>
            <img src={back_icon} />
          </button>
        </div>
      </div>
    </Modal>
  );
}
